import { Link } from "@tanstack/react-router";
import type { PostMeta } from "../content/posts";
import { formatDate } from "../content/posts";
import { categoryBySlug } from "../content/categories";

export function PostCard({ meta, size = "md", priority = false }: { meta: PostMeta; size?: "sm" | "md" | "lg"; priority?: boolean }) {
  const cat = categoryBySlug(meta.category);
  const thumb = `/blog/${meta.slug}.jpg`;
  return (
    <article
      className={`group relative border-t border-ink pt-5 ${size === "lg" ? "pb-8" : "pb-6"}`}
    >
      {size !== "sm" && (
        <Link
          to="/blog/$slug"
          params={{ slug: meta.slug }}
          aria-label={meta.title}
          className="block mb-5 overflow-hidden border border-rule bg-card"
        >
          <img
            src={thumb}
            alt={`Illustration for ${meta.title}`}
            width={1200}
            height={630}
            loading={priority ? "eager" : "lazy"}
            fetchPriority={priority ? "high" : undefined}
            className="w-full h-auto aspect-[1200/630] object-cover transition-transform duration-500 group-hover:scale-[1.02]"
          />
        </Link>
      )}
      <div className="flex items-center gap-3 mb-3">
        <span className="mono-label">
          {cat?.label ?? meta.category}
        </span>
        <span aria-hidden className="text-rule">·</span>
        <span className="mono-label">{formatDate(meta.pubDate)}</span>
        <span aria-hidden className="text-rule">·</span>
        <span className="mono-label">{meta.readMinutes} min read</span>
      </div>
      <h3
        className={
          size === "lg"
            ? "text-3xl md:text-4xl leading-[1.1] font-semibold"
            : size === "sm"
            ? "text-lg leading-snug font-semibold"
            : "text-2xl leading-snug font-semibold"
        }
        style={{ fontFamily: "var(--font-display)" }}
      >
        <Link
          to="/blog/$slug"
          params={{ slug: meta.slug }}
          className="hover:text-grade transition-colors"
        >
          {meta.title}
        </Link>
      </h3>
      {size !== "sm" && (
        <p className="mt-3 text-pencil leading-relaxed max-w-2xl">{meta.description}</p>
      )}
      <div className="mt-4">
        <Link
          to="/blog/$slug"
          params={{ slug: meta.slug }}
          className="mono-label text-ink hover:text-grade transition-colors"
        >
          Read the piece →
        </Link>
      </div>
    </article>
  );
}